import { customRuleCases } from "../constants/componentConstants";

export const Required = (message) => {
  return {
    required: true,
    message,
  };
};

export const notRequired = (message) => {
  return {
    required: false,
    message,
  };
};

export const maximumDigits = (message, maximum) => {
  return {
    max: maximum,
    message,
  };
};

export const minimumDigits = (message, minimum) => {
  return {
    min: minimum,
    message,
  };
};

export const allowOnlyDigits = (message) => {
  return {
    pattern: new RegExp("^[1-9]\\d*$"),
    message,
  };
};

export const allowOnlyDigitsZero = (message) => {
  return {
    pattern: new RegExp("^[0-9]\\d*$"),
    message,
  };
};

export const allowOnlyDigitsWithZero = (message) => {
  return {
    pattern: new RegExp("^[0-9]\\d*$"),
    message,
  };
};

export const allowValidHexCode = (message) => {
  return {
    pattern: new RegExp("^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$"),
    message,
  };
};

export const matchNDigits = (message) => {
  return {
    pattern: /^(\d{12})$/,
    message,
  };
};

export const allowOnlyDigitsOrFloats = (message) => {
  return {
    pattern: new RegExp("^(0*[1-9][0-9]*(\\.[0-9]+)?|0+\\.[0-9]*[1-9][0-9]*)$"),
    message,
  };
};

export function minimumText(minimum, message) {
  return { min: minimum, message };
}

export const validEmail = (message) => {
  return {
    type: "email",
    message,
  };
};

export const validUUID = (message) => {
  return {
    pattern: new RegExp(
      "^[[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}]*$",
      "gi"
    ),
    message,
  };
};

export const tenantUrlCheck = (message) => {
  return {
    pattern: new RegExp(/^[ A-Za-z0-9_-]*$/, "gi"),
    message,
  };
};

export const blankspaceCheck = (message) => {
  return {
    pattern: new RegExp(/^\w[a-zA-Z@#0-9.]*$/, "gi"),
    message,
  };
};

export const validUrl = (message) => {
  return {
    type: "url",
    message,
  };
};

export const nonZero = (message, minimum) => {
  return {
    pattern: new RegExp("[1-9]+[0-9]*(.[0-9]+)?"),
    message,
  };
};

export const alphaNumeric = (message) => {
  return {
    pattern: new RegExp(/\w*[a-zA-Z]+\w*/),
    message,
  };
};

export const base64 = (message) => {
  return {
    pattern: new RegExp(
      "^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$"
    ),
    message,
  };
};

export const customValidator = (toCompareValue, errorMsg, condition) => {
  return ({ getFieldValue }) => ({
    validator(_, value) {
      switch (condition) {
        case customRuleCases.lessThan:
          if (
            !value ||
            parseFloat(value) <
              (!toCompareValue ? 0 : parseFloat(toCompareValue))
          ) {
            return Promise.resolve();
          } else {
            return Promise.reject(new Error(errorMsg));
          }
        case customRuleCases.lessThanEqual:
          if (
            !value ||
            parseFloat(value) <=
              (!toCompareValue ? 0 : parseFloat(toCompareValue))
          ) {
            return Promise.resolve();
          } else {
            return Promise.reject(new Error(errorMsg));
          }
        case customRuleCases.greaterThan:
          if (
            !value ||
            parseFloat(value) >
              (!toCompareValue ? 0 : parseFloat(toCompareValue))
          ) {
            return Promise.resolve();
          } else {
            return Promise.reject(new Error(errorMsg));
          }
        case customRuleCases.greaterThanEqual:
          if (
            !value ||
            parseFloat(value) >=
              (!toCompareValue ? 0 : parseFloat(toCompareValue))
          ) {
            return Promise.resolve();
          } else {
            return Promise.reject(new Error(errorMsg));
          }
        case customRuleCases.maxTagLength:
          if (!value || value?.length <= toCompareValue) {
            return Promise.resolve();
          } else {
            return Promise.reject(new Error(errorMsg));
          }
        case customRuleCases.password:
          if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/.test(value)) {
            return Promise.resolve();
          } else {
            return Promise.reject(new Error(errorMsg));
          }
        default:
          return Promise.reject(new Error(errorMsg));
      }
    },
  });
};

export const customErrorCreator = (errorMsg) => {
  return ({ getFieldValue }) => ({
    validator(_) {
      return Promise.reject(new Error(errorMsg));
    },
  });
};

export const customResolve = () => {
  return ({ getFieldValue }) => ({
    validator(_) {
      return Promise.resolve();
    },
  });
};
